import { ContextStore } from 'bernie-core';
import { Logger } from 'bernie-logger';
import { bffFetch, bffFetchPost, Headers } from './bff-fetch';

export class ShortlistReplayApiSource {
  private host: string;
  private logger: Logger;
  private forwardedHeaders: Headers;

  constructor(host = '', logger, forwardedHeaders: Headers = {}) {
    this.host = host;
    this.logger = logger;
    this.forwardedHeaders = forwardedHeaders;
  }

  public fetch(context: ContextStore, params: any) {
    return bffFetch(this.host, 'replay', context, params, this.logger, this.forwardedHeaders);
  }

  public fetchReplayRemoveHotels(context: ContextStore, hotelId: number) {
    return bffFetchPost(this.host, `replay/${hotelId}`, context, null, this.logger, this.forwardedHeaders);
  }
}
